import { map, assocPath } from 'ramda'
const pages = [
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404/index'),
    index: '999',
    requireLogin: false
  },
  {
    path: '*', // 此处需特别注意置于最底部
    redirect: '/404'
  }
]

export default pages |> map(assocPath(['meta', 'requireLogin'], false))
